const router = useRouter();

export function scrollTop() {
  const element = document.querySelector('#scrolling');
  if (element !== null) element.scrollTop = 0;
}

export function scrollIntoView(
  element: HTMLElement,
  block: ScrollLogicalPosition = 'nearest',
  behavior: ScrollBehavior = 'smooth',
): void {
  if (element) element.scrollIntoView({block, behavior});
}

export const handleHashScroll = () => {
  const hash = window.location.hash.slice(1);
  if (!hash) return;

  const element = document.getElementById(hash);
  if (element) {
    scrollIntoView(element, 'start');
    // remove the hash so navigating back and forth isnt annoying
    router?.replace({hash: ''});
  }
};
